import Parse from "parse";
import { useEffect, useState } from "react";
import { Bikes_Allowed } from "../js/parsegenerated";

export function useBikesAllowed() {
  const [ba, setBA] = useState<Bikes_Allowed[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Bikes_Allowed).find().then(setBA);
  }, [reload]);

  return [
    ba,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Bikes_Allowed[], () => void];
}
